<template>
	<v-content>
		<v-container fluid pa-0>
			<app-header
				:title="$route.meta.title"
				:logo-url="logoUrl"
				:is-visible="!isVisible"
			/>
			<app-sidebar
				@active-route="getRoutes"
				:toggle="isVisible"
				:is-visible="!isVisible"
				@toggle-sidebar="changeToggle"
				@open="toggleSidebar"
			/>
			<section class="section-margin">
				<slot></slot>
			</section>
		</v-container>
	</v-content>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import appHeader from '@/components/shared/app-header';
import appSidebar from '@/components/shared/app-sidebar';
import appSubheader from '@/components/shared/app-subheader';

function changeToggle(value) {
	this.isVisible = value;
}

function closeNotificationsModal() {
	this.action.active = false;
	this.action.open = false;
}

function getRoutes(routes) {
	this.routes = routes;
	const module = this.routes.find(mod => mod.name === this.$route.meta.title) || {};
	this.logoUrl = module.pathIcon;
}

function notifications() {
	const allNotifications = [];
	if (this.productsNotifications.length > 0) {
		this.productsNotifications.forEach((productNot) => {
			allNotifications.push(productNot);
		});
	}
	if (this.salesNotifications.length > 0) {
		this.salesNotifications.forEach((saleNot) => {
			allNotifications.push(saleNot);
		});
	}
	return allNotifications;
}

function openNotificationsModal() {
	this.action.active = true;
	this.action.open = true;
}

function quantityNotifications() {
	return 0;
}

function toggleSidebar() {
	this.isVisible = !this.isVisible;
}

function $route(value) {
	const module = this.routes.find(mod => mod.name === value.meta.title) || {};
	this.logoUrl = module.pathIcon || this.$route.meta.logo;
}

function data() {
	return {
		action: {
			active: false,
			code: 'NOT',
			open: false,
			title: 'Notificaciones',
			width: 468,
		},
		isVisible: false,
		loading: false,
		logoUrl: '',
		routes: [],
	};
}

function showIndeterminate() {
	return this.$store.getters.indeterminate;
}

export default {
	name: 'layout-admin',
	components: {
		actionSidebar,
		appHeader,
		appSidebar,
		appSubheader,
	},
	computed: {
		notifications,
		quantityNotifications,
		showIndeterminate,
	},
	data,
	methods: {
		closeNotificationsModal,
		getRoutes,
		openNotificationsModal,
		toggleSidebar,
		changeToggle,
	},
	watch: {
		$route,
	},
};
</script>



// WEBPACK FOOTER //
// src/layouts/layout-admin.vue